export const VDP = 'VDP';
export const SRP = 'SRP';
export const SECTIONS_VDP_PAGE_ID_PARTIAL = 'DETAIL_RESPONSIVE_SECTIONS_AUTO';
